export const nameChange = {
  'filter_user_first_name': 'Name',
  'filter_user_last_name': 'Surname',
  'filter_user_email' : 'Email',
  'filter_user_is_active' : 'Status',
  'filter_user_typology': 'Typology',
  'filter_user_is_active': 'Active'
}